import React from "react";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import downloadIcon from '../../../assets/img/download_icon.png';
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import { Link, withRouter } from "react-router-dom";
import Image from "react-graceful-image";
import { CSVDownloader } from 'react-papaparse'

var moment = require("moment");

class ViewOrderProductsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            dataToDownload: [],
            exportAttsMap: {},
            all_columns: [],
        };
    }

    downloadData = () => {
        this.props.getOrderProductsCall({ order_id: this.props.order_id, page: 1, pageSize: -1 }).then(response => {
            var data_to_download = []
            const columnsData = this.getColumns();
            for (var index = 0; index < this.props.products.length; index++) {
                let record_to_download = {};
                var temp = this.props.products[index];
                record_to_download["Zabin Order ID"] = this.props.match.params.id;
                for (var colIndex = 0; colIndex < columnsData.length; colIndex++) {
                    if (columnsData[colIndex].excExp) {
                        if (this.state.exportAttsMap[columnsData[colIndex].title]) {
                            record_to_download[this.state.exportAttsMap[columnsData[colIndex].title]] = temp[columnsData[colIndex].accessor]

                        } else {
                            record_to_download[columnsData[colIndex].Header] = temp[columnsData[colIndex].accessor]
                        }
                    }
                    else if (columnsData[colIndex].accessor === "tag_layout") {
                        if (this.state.exportAttsMap[columnsData[colIndex].title]) {
                            record_to_download[this.state.exportAttsMap[columnsData[colIndex].title]] = temp[columnsData[colIndex].accessor] ? temp[columnsData[colIndex].accessor].title : ''
                        } else {
                            record_to_download[columnsData[colIndex].Header] = temp[columnsData[colIndex].accessor] ? temp[columnsData[colIndex].accessor].title : ''
                        }
                    }
                }
                data_to_download.push(record_to_download)
            }
            this.setState({ dataToDownload: data_to_download })
        });
    }

    getColumns = () => {
        const columnArrays = this.props.productAttributesProp.map(col => {
            if (col.data_type === 'url') {
                return {
                    Header: col.grid_label,
                    title: col.title,
                    accessor: col.db_column,
                    excExp: col.exportable,
                    className: "action-center",
                    show: col.show_on_grid,
                    Cell: ({ value }) => (
                        <React.Fragment>
                            <Link to={value} target="_blank" title="Download" download><img src={downloadIcon} alt='img' /></Link>
                        </React.Fragment>
                    )
                };
            }
            else {
                return {
                    Header: col.grid_label,
                    title: col.title,
                    accessor: col.db_column,
                    className: "action-center",
                    excExp: col.exportable,
                    show: col.show_on_grid
                };
            }
        });
        const orderColumnArrays = this.props.orderAttributesProp.map(col => {
            return {
                Header: col.cart_label,
                title: col.title,
                accessor: col.db_column,
                className: "action-center",
                excExp: true
            };
        });

        const allColumnsArrays = [
            ...columnArrays,
            {
                Header: 'Tag Layout',
                accessor: "tag_layout",
                Cell: ({ value }) => (
                    <Image
                        src={process.env.REACT_APP_S3_THUMBNAIL_PATH + (value ? value.path : '')}
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100px",
                            margin: "0 auto"
                        }}
                        alt={value ? value.title : ''}
                        retry={{ count: 10, delay: 2 }}
                        placeholderColor="#ccc"
                    />
                ),
                className: "action-center text-capitalize"
            },
            ...orderColumnArrays
        ];

        return allColumnsArrays;
    }


    componentDidMount() {
        let tempMap = { ...this.state.exportAttsMap };
        this.props.exportAttributes.forEach(item => {
            tempMap[item.title] = item.header_label
        })
        this.setState({
            ...this.state,
            all_columns: this.getColumns(),
            exportAttsMap: tempMap,

        }, () => {
            this.downloadData();
        });
    }

    render() {
        const { filtered } = this.state;
        const { pages, loading } = this.props;

        const columns = [
            {
                Header: "States Listing",
                headerClassName: "headerPagination",
                columns: this.state.all_columns
            }
        ];

        return (
            <React.Fragment>
                <Col md={6} className="mt-sm downloadCsv">

                    <React.Fragment>
                        <div className="downloadCsv">
                            <CSVDownloader
                                data={this.state.dataToDownload}
                                ref={(r) => this.csvLink = r}
                                filename={"Order_Products" + moment().format('MMM/D/YYYY')}
                                config={{
                                    delimiter: '\t',
                                }}
                                bom={true}
                            >
                                <button type="button">
                                    Download
                                </button>
                            </CSVDownloader>
                        </div>
                    </React.Fragment>

                </Col>
                <Col md={12}>
                    <ReactTable
                        ref={(r) => this.reactTable = r}
                        noDataText="No matching products found"
                        data={this.props.productsData}
                        pages={pages}
                        loading={loading}
                        columns={columns}
                        filtered={filtered}
                        defaultPageSize={100}
                        className="resetTable listing responsive"
                        pageData={this.props.productsPaginationData}
                        manual
                        onFetchData={(state, instance) => {
                            var sort =
                                state.sorted.length === 0
                                    ? ""
                                    : state.sorted[0].id +
                                    ",desc:" +
                                    state.sorted[0].desc;
                            state.pageData(
                                state.page + 1,
                                this.props.filtered,
                                sort,
                                state.pageSize
                            );
                        }}
                    /></Col>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        getOrderProductsCall: (data) => {
            return dispatch(createOrderActions.getOrderProductsPagination(data));
        },
    });
};

function mapStateToProps(state) {
    const {
        productsDataAll
    } = state.createOrdersReducer;

    return {
        products: productsDataAll
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewOrderProductsList));



// WEBPACK FOOTER //
// ./src/components/Admin/Order/ViewOrderProductsList.js